import {UI} from "../ui/UI";

import {Config} from "../Config";

/**
 * Handle initialization of the app
 */
export class Initialize {

    /**
     * Perform app initialization
     */
    public static async do() {

        // set debug output as is appropriate
        Initialize.setDebug();

        // initialize the UI
        UI.initialize();

    }

    /**
     * Set debug output accordingly
     */
    private static setDebug() {

        // if we should debug
        if (Config.DebugEnabled == true) {
            localStorage.debug = Config.Debug
        }
        else {
            localStorage.removeItem('debug');
        }
    }
}